import { html } from 'lit';
const MultiPeople =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M8.562 3.985a3.834 3.834 0 1 0 0 7.668 3.834 3.834 0 0 0 0-7.668M6.228 7.819a2.334 2.334 0 1 1 4.668 0 2.334 2.334 0 0 1-4.668 0M8.562 12.466a6.15 6.15 0 0 0-5.9 4.414 1.84 1.84 0 0 0 .42 1.785c.403.44.997.698 1.625.698h7.71a2 2 0 0 0 .339-.023h6.6c.564 0 1.1-.232 1.463-.63.375-.41.564-1 .381-1.623a5.33 5.33 0 0 0-8.266-2.795 6.13 6.13 0 0 0-4.372-1.826m-4.46 4.836a4.65 4.65 0 0 1 8.92 0 .34.34 0 0 1-.087.35.7.7 0 0 1-.518.21h-7.71a.7.7 0 0 1-.518-.21.34.34 0 0 1-.087-.35m9.75-1.823c.258.436.464.905.61 1.401.098.335.098.661.025.96h4.87c.16 0 .288-.068.356-.142a.2.2 0 0 0 .053-.091.2.2 0 0 0-.005-.097 3.83 3.83 0 0 0-5.91-2.03" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M16.086 6.064a3.367 3.367 0 1 0 0 6.734 3.367 3.367 0 0 0 0-6.734m-1.867 3.367a1.867 1.867 0 1 1 3.734 0 1.867 1.867 0 0 1-3.734 0" clip-rule="evenodd"/>
  </svg>
`;
export default MultiPeople;
